import React, { useState, useEffect } from 'react'
import { Box, Paper, Text, Divider, Group, Flex, Button, Modal } from '@mantine/core'
import { useParams } from 'react-router-dom'
import { getListUserPoint, deleteUserPoint } from '../../../../../services/users'
import LoadingData from '../../../../ui/LoadingData'
import NoData from '../../../../ui/NoData'
import TableUserPoint from './TableUserPoint'
import FormAdjustUserPoint from './FormAdjustUserPoint'
import { modalDeleteDataUseId } from '../../../../ui/Prompt/modalDeleteDataUseId'

const labelTable = [
  {
    label: 'No.',
    width: 50
  },
  {
    label: 'Date',
    width: 'auto'
  },
  {
    label: 'Ref',
    width: 'auto'
  },
  {
    label: 'Type',
    width: 'auto'
  },
  {
    label: 'Label',
    width: 'auto'
  },
  {
    label: 'Point',
    width: 'auto'
  },
  {
    label: 'Action',
    width: 70
  },
]

const UserPoints = () => {
  const params = useParams()
  const userId = params.id

  const [loadingData, setLoadingData] = useState(true)
  const [userPointsList, setUserPointsList] = useState([])
  const [totalPoints, setTotalPoints] = useState(0)
  const [openModalForm, setOpenModalForm] = useState(false)
  const [detailData, setDetailData] = useState(null)

  const handleGetUserPoint = async () => {
    setLoadingData(true)
    const params = {
      sort: '-updated_at',
    }
    try {
      const response = await getListUserPoint(userId, params)
      if (response.success) {
        const { data } = response

        const remapData = data.map((val) => {
          return val.attributes
        })

        const countTotalPoint = data.reduce((accumulator, currentValue) => {
          const val = currentValue.attributes
          if (val.reward_type.value !== 2 && val.reward_type.value !== 5) {
            return accumulator + val.amount
          } else {
            return accumulator - val.amount
          }
        }, 0)

        setUserPointsList(remapData)
        setTotalPoints(countTotalPoint ? countTotalPoint : 0)
      } else {
        setUserPointsList([])
        setTotalPoints(0)
      }
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingData(false)
    }
  }

  useEffect(() => {
    handleGetUserPoint()
    // eslint-disable-next-line
  }, [userId])

  const actions = {
    edit: (val) => {
      setDetailData(val)
      setOpenModalForm(true)
    },
    delete: (val) => {
      modalDeleteDataUseId('User Point', userId, val.id, val.reward_type.label, deleteUserPoint, handleGetUserPoint)
    }
  }

  const handleAction = (val, type) => {
    return actions[type](val)
  }

  const onCloseModalForm = () => {
    setOpenModalForm(false)
  }

  return (
    <Box>
      <Paper my='xl' p='md' withBorder shadow='xs' radius='md'>
        <Text fw={500}>
          Point Balance History
        </Text>
        <Divider my='xs' />
        <Flex justify='flex-end'>
          <Button size='xs' onClick={() => setOpenModalForm(true)}>Add Point Balance</Button>
        </Flex>
        <Box my={20}>
          <Box>
            <Group mb={2} gap='xs'>
              <Text fz={12}>Point Balance: </Text>
              <Text fz={12} fw='bold'>{totalPoints} Orders</Text>
            </Group>
          </Box>
          {loadingData ? <LoadingData /> : userPointsList.length > 0 ? <TableUserPoint label={labelTable} data={userPointsList} actionMethod={handleAction} /> : <NoData />}
        </Box>
      </Paper>
      <Modal
        opened={openModalForm}
        onClose={onCloseModalForm}
        centered
        closeOnClickOutside={false}
        size='lg'
        title={<Text fw='Bold'>{detailData !== null ? 'Edit' : 'Add'} Point Balance</Text>}
        withCloseButton={false}
      >
        <FormAdjustUserPoint
          dataUserPoint={detailData}
          onCloseForm={onCloseModalForm}
          reloadList={handleGetUserPoint}
        />
      </Modal>
    </Box>
  )
}

export default UserPoints